var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUstLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    stroke: "#ffffff",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.942 45.532c4.351 0 8.691 1.844 10.687 5.182l-4.722 3.82c-1.607-1.448-3.566-2.505-6.004-2.505-2.633 0-3.917 1.075-3.917 2.076 0 1.328 1.228 2.103 3.917 2.766l2.411.586c6.802 1.64 9.302 4.792 9.302 8.734C24.616 71.383 19.98 75 12.23 75 7.894 75 2.548 73.183.487 69.445l4.723-3.82c1.912 1.939 4.076 3.11 6.98 3.11 2.514 0 4.51-.839 4.51-2.347 0-1.21-.911-1.677-3.402-2.301l-2.53-.625c-6.762-1.678-9.38-5.491-9.38-9.16 0-4.75 4.2-8.77 11.554-8.77zm54.941.81v6.613h-8.279v21.16h-7.65v-21.16h-8.278v-6.613h24.207zM7.618 0v16.46c0 3.279 1.871 5.146 4.916 5.146 3.044 0 4.877-1.867 4.877-5.146V0h7.617v16.424c0 7.635-4.57 12.234-12.455 12.234C4.376 28.658 0 23.864 0 16.424V0h7.618zm53.555 8.233V19.02H50.386V8.233h10.787z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUstLogo);
export default __webpack_public_path__ + "static/media/ust_logo.26ee0cb3f40f7d37463b46d1e5338dfd.svg";
export { ForwardRef as ReactComponent };